import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { CircularProgress, Box, Typography } from '@mui/material';

export default function AdminRoute({ children }) {
  const { isAuthenticated, isLoading, isAdmin } = useAuth();

  // Debug information
  console.log('AdminRoute Check:', {
    isAuthenticated,
    isLoading,
    isAdmin,
    user: useAuth().user,
    roles: useAuth().user?.roles,
    appMetadata: useAuth().user?.app_metadata
  });

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated || !isAdmin) {
    return <Navigate to="/" />;
  }

  return children;
}
